import createLogger from './create-logger';

export default function runTasks(tasks, log = false, prefix = 'run task') {
    const logFn = createLogger({ prefix, backgroundColor: 'lightcoral', enabled: log });
    return new Promise((resolve1) => {
        const promises = tasks.map(
            (task) =>
                new Promise((resolve2) => {
                    const start = window.performance.now();
                    const returned = task();
                    if (returned && returned.then) {
                        returned
                            .then(() => {
                                logFn(`${task.name} (async) (${window.performance.now() - start} ms)`);
                            })
                            .then(resolve2);
                    } else {
                        logFn(`${task.name} (sync) (${window.performance.now() - start} ms)`);
                        resolve2();
                    }
                }),
        );
        Promise.all(promises).then(resolve1);
    });
}
